module.exports = __webpack_public_path__ + "img/22exp.72bddc4f.jpg";